import { type tagType, type errorType } from '@/api/types/common';

export interface getTagsReqType extends tagType {
  /**
   * 用户ID或用户名
   */
  creator?: string;
  /**
   * 返回按照名称（name）、更新时间（updated）或创建时间（created）字段排序
   */
  order_by?: TagSortType.COMMITED | TagSortType.CREATED;
  /**
   * 当前页码
   */
  page?: string;
  /**
   * 每页的项目数
   */
  per_page?: string;
  /**
   * 返回与搜索条件匹配的标签列表
   */
  search?: string;
  /**
   * 返回排序为升序（asc）或降序（desc）
   */
  sort?: string;
  /**
   * 仅返回标签名称
   */
  view?: string;
}

export interface tagDetailType extends tagType {
  [propName: string]: any;
}

export interface commonTagsResType extends errorType {
  [propName: string]: any;
}

export interface createTagReqType {
  tag_name: string;
  ref: string;
  message?: string;
  release_description?: string;
  [propName: string]: any;
}

/** tag排序条件 */
export enum TagSortType {
  /** 按commit提交时间排序 */
  COMMITED = 'committed',
  /** 按创建时间排序 */
  CREATED = 'created'
};
